module.exports = __webpack_public_path__ + "static/img/3_1_7_2.299c8748.jpg";